export const honeybadgerConfig = import.meta.env.VITE_HONEYBADGER_API_KEY_JS
  ? {
    apiKey: import.meta.env.VITE_HONEYBADGER_API_KEY_JS,
    environment: import.meta.env.VITE_MODE
  }
  : null;
